import { HttpClient, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiConfiguration } from "../api-configuration";
import { BaseService } from "../base-service";
import { RequestBuilder } from "../request-builder";
import { StrictHttpResponse } from "../strict-http-response";
import { filter, map, Observable } from "rxjs";


@Injectable({
  providedIn: 'root',
})
export class AnalyticEventLogService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  static readonly ApiServicesAppQuotationAnalyticsEventsLogsPurchase = '/api/Quotation/PurchaseEventLog/Purchase';


  apiServicesAppQuotationQuotePost$EventLogPurchase$Response(body?: any): Observable<StrictHttpResponse<any>> {
      const rb = new RequestBuilder(this.rootUrl, AnalyticEventLogService.ApiServicesAppQuotationAnalyticsEventsLogsPurchase, 'post');
      rb.body(body, 'application/*+json');

      return this.http
        .request(
          rb.build({
            responseType: 'text',
            accept: 'text/plain',
          })
        )
        .pipe(
          filter((r: any) => r instanceof HttpResponse),
          map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<any>;
          })
        );
    }

    apiServicesAppQuotationQuotePost$EventLogPurchase(body?: any): Observable<any> {
      return this.apiServicesAppQuotationQuotePost$EventLogPurchase$Response(body).pipe(
        map((r: StrictHttpResponse<any>) => r.body)
      );
    }
}
